// @ts-ignore
import type { ComposerTranslation } from '@nuxtjs/i18n/dist/runtime/composables';

import { useSearchStore } from '../store';

import type { SeoMetadata } from '~~/domains/graphql';
import { useSearchSeoAsyncData } from '~~/domains/graphql';
import type { Metadata } from '~~/composables/useSeoMetadata';

export async function useSearchSeo(t: ComposerTranslation) {
  const { data } = await useSearchSeoAsyncData();
  const searchSeo = computed(() => data.value?.searchSeo);
  const searchStore = useSearchStore();

  const location = computed(() => searchStore.destination?.text);
  const type = computed(() => searchStore.selectedExperienceCategoryTitle);

  const metadata = computed<Metadata>(() => {
    const seo: Partial<SeoMetadata> = {
      title: searchSeo.value?.title,
      description: searchSeo.value?.description,
      ogDescription: searchSeo.value?.ogDescription,
      ogImage: searchSeo.value?.ogImage,
      ogTitle: searchSeo.value?.ogTitle,
    };

    if (location.value || type.value) {
      seo.title = t('seo.search.withValue.title', {
        type: type.value,
        location: location.value,
      });

      const dynamicDescription = t('seo.search.withValue.description', {
        type: type.value,
        location: location.value,
      });

      if (seo.description) {
        seo.description = `${dynamicDescription} ${seo.description}`;
      } else {
        seo.description = dynamicDescription;
      }
    }

    return seo;
  });

  useSeoMetadata({
    metadata,
    fallback: {
      title: t('seo.search.title'),
      description: t('seo.search.description'),
    },
  });
}
